import React, { useCallback } from "react";

import { faIndent, faOutdent } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSlate } from "slate-react";

import ElementType from "../../../../type/slate/ElementType";
import toggleBlock from "../../util/toggleBlock";
import ToggleButton from "../ToggleButton";

import ActionTooltipWrapper from "./ActionTooltipWrapper";

interface IndentControlProps {
  offset: -1 | 1;
}

const IndentControl = ({ offset }: IndentControlProps) => {
  const editor = useSlate();

  const handleAction = useCallback(() => {
    toggleBlock(editor, ElementType.INDENT, {
      indentIncrement: offset,
    });
  }, [editor, offset]);

  return (
    <ActionTooltipWrapper
      translationString={
        offset === 1 ? "ui.emailBody.toolbar.indentMore" : "ui.emailBody.toolbar.indentLess"
      }
    >
      <ToggleButton onClick={handleAction}>
        <FontAwesomeIcon icon={offset === 1 ? faIndent : faOutdent} size="xs" />
      </ToggleButton>
    </ActionTooltipWrapper>
  );
};

export default IndentControl;
